import React, { useEffect, useState } from 'react'
import PriceSlider from 'react-slick'
import { useSelector } from 'react-redux'
/* --------------------------------------------- */
import './inAppPurchase.scss'
import { Wrapper } from './style'
import PurchaseRailItem from './PurchaseRailItem'
import utils from '../../utils/utils'
import { hydratePageComponent } from '../../utils/contentfulHandler'
/* --------------------------------------------- */
// PurchaseRail component with PurchaseRailItems.
const PurchaseRail = ({ type, theme, productList = [], railTittle, appMessages, isPurchasedProduct }) => {
    const [railInfo, updateRailInfo] = useState(null)
    /* --------------------------------------------- */
    const { catalogConfig = {} } = useSelector(store => store.catalog)
    /* --------------------------------------------- */
    const {
        productListingComponent
    } = catalogConfig

    useEffect(() => {
        if (utils.isNull(productListingComponent)) return
        const {
            config: rConfig,
            componentStyles: rStyle,
            componentTheme: rTheme
        } = hydratePageComponent(productListingComponent, { contentType: type })
        const railInfo = {
            ...rConfig,
            style: rStyle[0],
            componentTheme: rTheme
        }
        updateRailInfo(railInfo)
    }, [productListingComponent, type])

    const settings = {
        dots: false,
        infinite: false,
        arrows: false,
        speed: 500,
        slidesToShow: 2.1,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                }
            },]
    }

    return (<>
        {railInfo && <Wrapper {...{ theme }}>
            {productList.length ? <div className={`inApp-purchase-wrapper ${isPurchasedProduct ? 'watching-with-wrapper' : ''}`}>
                <h1 className='rail-title'>{railTittle}</h1>
                { railInfo.style && railInfo.style.type && railInfo.style.type === 'rail' ? <div className='inApp-purchase-rail'>
                    <PriceSlider {...settings}>
                        {productList.map((singleProduct, i) => {
                            return <PurchaseRailItem key={i} {...{ ...singleProduct, theme: railInfo.componentTheme, appMessages, isPurchasedProduct }} />
                        })}
                    </PriceSlider>
                </div>
                    :
                    <div className='inApp-purchase-list'>
                        {productList.map((singleProduct, i) => {
                            return <PurchaseRailItem key={i} {...{ ...singleProduct, theme: railInfo.componentTheme, appMessages, isPurchasedProduct }} />
                        })}
                    </div>}
            </div> : null}
        </Wrapper>}
    </>
    )
}
/* ---------------------------------------------------------------------------------------------------- */
export default PurchaseRail
/* ---------------------------------------------------------------------------------------------------- */
